<template lang="pug">
.check_wrapper(
  @click='click',
  @mouseover='hover(true)',
  @mouseleave='hover(false)',
  :class='{ disabled: disabled }',
  :style='getStyle'
)
  .check_box(:class='{ checked: dataInput }')
    AppSvgIcon.apply(
      :color-mode='"stroke"',
      :template='$ui.IconSvgComponents.apply',
      :size='"auto"'
    )
  .check_box_label
    | {{ this.label || '' }}
    slot
</template>

<script>
import Apply from '../AppSvgIconNew/templates/icons/apply';
import { getColorByName } from '@/uikit/utils/colorUtils';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
export default {
  name: 'AppCheckBox',
  components: { Apply, AppSvgIcon },
  props: {
    input: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      upHere: false,
      dataInput: this.input,
    };
  },
  created() {
    this.inputData();
  },
  watch: {
    input(value) {
      this.dataInput = value;
    },
  },
  computed: {
    getStyle() {
      let ret = {};
      if (this.disabled && this.input) {
        ret['--apply-color'] = getColorByName('_color_night_light');
      } else if (this.disabled && !this.input) {
        ret['--apply-color'] = getColorByName('_color_neutral_light');
      } else if (this.upHere && !this.input) {
        ret['--apply-color'] = getColorByName('_color_azure_dark');
      } else {
        ret['--apply-color'] = getColorByName('_color_snow_light');
      }
      return ret;
    },
  },
  methods: {
    inputData() {
      this.$emit('input', this.dataInput);
    },
    click() {
      this.dataInput = !this.dataInput;
      this.inputData();
    },
    hover(over) {
      this.upHere = over;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/uikit/stylus/index'
.check_wrapper:hover
  .check_box.checked
    background: #6FB7EB;
.check_wrapper
  display flex
  .check_box.checked
    background: #279DF2;
    border: none
  .check_box
    .apply
      color: var(--apply-color)
    &:hover {
      background: #FFFFFF;
    }
    width: 20px;
    min-width: 20px;
    height: 20px;
    background: #FFFFFF;
    border: 1px solid #939393;
    display flex
    justify-content center
    align-items center
    margin-right 5px
    cursor pointer
  .check_box_label
    font-size: 12px;
    align-self: center;
.disabled.check_wrapper
  .check_box
    background-color #B6B6B6;
    border none;
  pointer-events none;
</style>



// WEBPACK FOOTER //
// AppCheckBox.vue?2f3c4344